<!-- ========== Left Sidebar Start ========== -->
<div class="vertical-menu">

  <!-- LOGO -->
  <div class="navbar-brand-box px-18px">
    <a (click)="logoClick()" class="logo logo-light">
      <span class="logo-lg">
        <img alt="" height="22" src="/assets/img/samsungcare.png">
      </span>
      <span class="logo-sm btn-cursor">
        <img class="logo" src="/assets/img/samsungcare.svg" width="45px">
      </span>
    </a>
  </div>

  <!--- Sidemenu -->

  <ngx-simplebar *ngIf="menuItems.length" class="sidebar-menu-scroll" style="max-height: 100vh; z-index: 100;">
    <!--- Sidemenu -->
    <div id="sidebar-menu">
      <!-- Left Menu Start -->
      <ul class="metismenu list-unstyled" id="side-menu">

        <ng-container *ngFor="let item of menuItems">
          <li *ngIf="item.isTitle" class="menu-title">{{ item.label | translate }}</li>

          <li *ngIf="!item.isTitle && !item.isLayout" [ngClass]="{'mm-active': item === selectedMenu}">
            <a *ngIf="hasItems(item)" [ngClass]="{'has-arrow': !item.badge, 'has-dropdown': item.badge}"
               class="is-parent"
               href="javascript:void(0);">
              <span class="menu-item"> {{ item.label | translate }}</span>
              <span *ngIf="item.badge" class="badge rounded-pill float-end bg-{{item.badge.variant}}">
                {{ item.badge.text| translate }}
              </span>
            </a>
            <a (click)="menuClick(item)" *ngIf="!hasItems(item)" [ngClass]="{'active': item === selectedMenu}"
               [routerLink]="item.link"
               class="side-nav-link-ref" matTooltip="{{ item.label | translate }}"
               matTooltipPosition="right" routerLinkActive="active">
              <font-awesome [icon]="'me-1 nav-icon '+fontAwesomeType+' '+item.icon"></font-awesome>
            </a>
          </li>

        </ng-container>

      </ul>
    </div>
    <!-- Sidebar -->
  </ngx-simplebar>
  <!-- Sidebar -->

</div>
<!-- Left Sidebar End -->
